import React from 'react'
import Heading from 'shared/ui/Heading'
import { Field } from 'shared/ui/SimpleForm'

export default function TrainingContactForm() {
  return (
    <div className="spacing">
      <Heading size={3}>Contact Us</Heading>
      <form
        action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8"
        method="POST"
        oid="00D3i000000rmWq"
        className="spacing-small"
      >
        <input type="hidden" name="oid" value="00D3i000000rmWq" />
        <input type="hidden" name="retURL" value="http://reacttraining.com/thank-you" />
        <Field name="first_name" label="First Name" placeholder="Jane" required />
        <Field name="last_name" label="Last Name" placeholder="Doe" required />
        <Field name="email" type="email" label="Email" placeholder="jane@email.com" required />
        <Field name="company" label="Company" placeholder="Very Serious Inc." required />
        <Field name="title" label="Role/Title" placeholder="CTO" required />
        <Field type="tel" name="phone" label="Phone" placeholder="555-867-5309" />
        <Field
          type="number"
          label="Team Size"
          name="00N3i0000093qmN"
          defaultValue="20"
          min="0"
          max="100"
        />

        <Field name="lead_source" label="How did you hear about us?">
          {(props) => (
            <select {...props}>
              <option value="">I don't know/remember</option>
              <option value="Open Source">Your open source work</option>
              <option value="Workshop">Somebody in the company attended a public workshop</option>
              <option value="Employee Referral">One of our employees recommended you</option>
              <option value="Word of mouth">Word of mouth</option>
              <option value="Search Engine">Search engine</option>
              <option value="Twitter">Your tweets are the best</option>
              <option value="Other">Other</option>
            </select>
          )}
        </Field>

        <Field label="Message" name="description">
          {(props) => (
            <textarea
              {...props}
              placeholder="What questions do you have? Tell us what you're looking for!"
              className="form-field"
            />
          )}
        </Field>
        <footer className="spacing">
          <button type="submit" className="button block">
            Send Message
          </button>
          <div className="text-small">
            Or email us at <a href="mailto:hello@reacttraining.com">hello@reacttraining.com</a>
          </div>
        </footer>
      </form>
    </div>
  )
}
